import React from 'react';

import Head from 'next/head';

import Image from 'next/image';

import {
  Box,
  Button,
  Container
} from '@mui/material';

import TopNav from './TopNav';
import BottomNav from './BottomNav';
import Link from './Link';

export default function ServerError({ statusCode }) {

  return (
    <>
      <Head>
        <title>{ statusCode } Server Error - MechanicBuddy</title>
      </Head>
      <TopNav />

      <Container
        maxWidth="sm"
        sx={{
          alignItems: "center",
          minHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center"
        }}
      >
        <Box
          fontSize="h4.fontSize"
          textAlign="center"
          mb={2}
        >
          Something went wrong
        </Box>
        <Image src="/icons/404.svg" width={200} height={200} alt="End of road" />
        <Box
          fontSize="h5.fontSize"
          textAlign="center"
          my={2}
        >
          A server error occured. Please <Link color="secondary" href="/contact-us">contact us</Link> if this issue persists or visit one of the pages below.
        </Box>

        <Button
          color="secondary"
          variant="contained"
          href="/"
        >Go Home</Button>
      </Container>

      <BottomNav />
    </>
  )
}
